<template>
  <div
    class="footer-wrapper"
    :class="{ 'footer-wrapper--videoresume': isVideoresume }"
    :style="{ backgroundColor: background || '#E5E5E5' }"
  >
    <div
      class="footer"
      :class="{
        'is-landing': type === 'landing',
        'is-adaptive': is_adaptive,
        'public-response': public_response
      }"
    >
      <div class="footer-copyright mobile-hidden">
        <a
          class="footer-copyright-img"
          target="_blank"
          rel="noopener"
          :href="
            !isVideoresume
              ? `https://${this.domain}/`
              : `https://vcv.me/${this.lang === 'ru' ? 'ru' : ''}`
          "
        >
          <img v-if="!isVideoresume" src="/static/images/elements/footer-recruiter.svg" />
          <div v-else class="footer-copyright-round"></div>
        </a>
        <span class="copyright footer-group footer-text">
          {{ $tr('copyright_landing', { year: year }) }}
        </span>
        <a
          class="footer-text tablet-hidden"
          :href="support.email_link"
          target="_blank"
          rel="noopener"
        >
          {{ support.email_text }}
        </a>
        <a
          v-if="lang === 'ru'"
          class="footer-text tablet-hidden"
          :href="support.phone_link"
          target="_blank"
          rel="noopener"
        >
          {{ support.phone_text }}
        </a>
      </div>

      <a
        class="footer-center"
        target="_blank"
        rel="noopener"
        :href="
          !isVideoresume
            ? `https://${this.domain}/`
            : `https://vcv.me/${this.lang === 'ru' ? 'ru' : ''}`
        "
      >
        <span>Powered by</span>
        <img
          v-if="!isVideoresume"
          class="footer-center-logo"
          src="/static/images/elements/vcv-recruiter-footer-logo.svg"
        />
        <span v-else class="footer-center-logo-text">&nbsp;vcv.me&nbsp;</span>
        <span>with</span>
        <img
          :src="
            !isVideoresume
              ? '/static/images/elements/footer-heart.svg'
              : '/static/images/elements/footer-heart-b2c.svg'
          "
        />
      </a>

      <div class="footer-copyright mobile-info">
        <a class="footer-text" :href="support.email_link" target="_blank" rel="noopener">
          {{ support.email_text }}
        </a>
        <a
          v-if="lang === 'ru'"
          class="footer-text"
          :href="support.phone_link"
          target="_blank"
          rel="noopener"
        >
          {{ support.phone_text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Vfooter',

  props: {
    type: {
      type: String,
      default: 'main'
    },

    background: {
      type: String,
      default: '#E5E5E5'
    },

    company_language: {
      default: null
    },

    isVideoresume: {
      default: false
    }
  },

  data() {
    return {
      year: new Date().getFullYear()
    };
  },

  computed: {
    ...mapState(['locale']),

    lang() {
      if (!this.company_language) {
        return this.locale.value;
      }
      return this.company_language.toLowerCase();
    },

    domain() {
      switch (this.lang) {
        case 'ru':
          return 'vcv.ru';
        default:
          return 'vcv.ai';
      }
    },

    support() {
      const phone_link = this.phone_link;
      switch (this.lang) {
        case 'ru':
          return {
            email_link:
              this.domain === 'vcv.ru'
                ? `mailto:support@${this.domain}`
                : `mailto:ask@${this.domain}`,

            email_text: this.domain === 'vcv.ru' ? `support@${this.domain}` : `ask@${this.domain}`,
            phone_link: 'tel:+78002007790',
            phone_text: '+7 (800) 200 77 90'
          };
        default:
          return {
            email_link:
              this.domain === 'vcv.ru'
                ? `mailto:support@${this.domain}`
                : `mailto:ask@${this.domain}`,

            email_text: this.domain === 'vcv.ru' ? `support@${this.domain}` : `ask@${this.domain}`,
            phone_text: phone_link,
            phone_link: `tel:${phone_link.replace(/([-, ])/g, '')}`
          };
      }
    },

    phone_link() {
      return this.$tr('common.en.phone', 'en');
    },

    showPrivacyPolicy() {
      return this.type === 'landing';
    },

    userAgreement() {
      return this.type === 'landing' && this.lang === 'ru';
    },

    showSupport() {
      return this.type === 'landing';
    },

    is_adaptive() {
      return this.$route.meta ? this.$route.meta.is_adaptive : null;
    },

    public_response() {
      return this.$route.meta ? this.$route.meta.public_response : null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/variables.scss';

.footer-wrapper {
  position: relative;
  border-top: 1px solid #d2d6e0;
  min-height: 60px;
  box-sizing: border-box;
  padding: 12px 0;
  margin-top: auto;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 99999;

  @include tablet {
    min-height: 40px;
    padding: 3px 0;
  }
  @include mobile {
    min-height: 40px;
    padding: 3px 0;
  }
  .footer {
    position: relative;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    @include tablet {
      max-width: 920px;
      padding-left: 1rem;
      padding-right: 1rem;
      align-items: center;
      justify-content: space-between;

      .footer-copyright {
        position: absolute;
        left: 1rem;
        top: 0;

        &.mobile-info {
          left: auto;
          right: 1rem;
          top: 7px;
        }
      }
    }

    @include mobile {
      padding-left: 1rem;
      padding-right: 1rem;
      .footer-copyright {
        position: static;
      }
    }

    &:not(.is-landing):not(.is-adaptive):not(.public-response) {
      @include desktop {
        padding-left: 20px;
        padding-right: 20px;
        max-width: 100%;
        width: 1240px;
        box-sizing: border-box;
      }

      @include tablet {
        max-width: 100%;
        width: 1240px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
      }

      @include mobile {
        max-width: 100%;
        width: 1240px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
      }
    }

    .copyright {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #9faab6;
    }

    > div {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    a.footer-text {
      margin-bottom: 3px;
      margin-right: 25px;

      @include tablet {
        margin-bottom: 0;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }

      @include mobile {
        margin-right: 0;
      }
    }

    .footer-group {
      display: inline-block;
      margin: 0px 34px 3px 0px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #9faab6;

      @include tablet {
        margin-bottom: 0;
      }

      &:last-child {
        margin-right: 28px;
      }

      a {
        color: #9faab6;

        &:hover,
        &:focus,
        &:active {
          color: $green;
        }
      }
    }
    .link {
      white-space: nowrap;
    }

    .logo-icon {
      width: 24px;
    }
  }
}

.footer-center {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  text-align: center;
  color: #607183;
  transition: color linear 0.3s;
  display: inline-flex;
  align-items: center;

  @include tablet {
    width: 100%;
    justify-content: center;
  }

  @include mobile {
    width: auto;
    justify-content: flex-start;
  }

  img {
    margin-left: 4px;
    height: 20px;
  }
}

.footer-copyright {
  position: absolute;
  top: 3px;
  left: 24px;
  display: flex;
  align-items: center;

  @include mobile {
    position: static;
  }

  span {
    margin-right: 30px;
  }

  a {
    color: #9faab6;
    transition: color ease-in-out 0.4s;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    margin-right: 9px;
    display: flex;

    &:hover {
      color: $green-hover;
    }
  }
}

.footer-copyright-img {
  margin-right: 9px;
}

.footer-center-logo {
  margin-left: 2px;
  margin-right: 4px;
  display: flex;
  align-items: center;
  height: 20px;
}

.mobile-info {
  display: none !important;
  align-items: center !important;

  @media only screen and (max-width: 1024px) {
    display: flex !important;
  }

  @media only screen and (max-width: 650px) {
    flex-direction: column-reverse;
    align-items: flex-end !important;
  }
}

.tablet-hidden {
  @media only screen and (max-width: 1024px) {
    display: none !important;
  }
}

.mobile-hidden {
  @media only screen and (max-width: 465px) {
    display: none !important;
  }
}

.footer-wrapper--videoresume {
  border-top: 0;
  .footer-copyright {
    top: 9px;
  }
  .footer-copyright a {
    margin-right: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #8d8d8d;

    &:hover,
    &:focus,
    &:active {
      transition: color 0.35s ease !important;
      background: linear-gradient(278deg, #535dc1 0%, #a364d6 100%) !important;
      -webkit-background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
    }
  }
  .footer-copyright-round {
    width: 20px;
    height: 20px;
    background: $green;
    border-radius: 50%;
  }

  .copyright {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #8d8d8d;
  }

  .footer-center {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    text-transform: lowercase;
    text-align: center;
    color: #8d8d8d;

    a {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d8d8d;

      &:hover,
      &:focus,
      &:active {
        transition: color 0.35s ease !important;
        background: linear-gradient(278deg, #535dc1 0%, #a364d6 100%) !important;
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent !important;
      }
    }
  }

  .footer-center-logo-text {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    color: #666666;
  }

  a.footer-text,
  .footer-group {
    margin-bottom: 0 !important;
  }

  .footer-group {
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 12px !important;
    line-height: 16px !important;
    color: #8d8d8d !important;
  }
}
</style>
